﻿import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NO_USER_ASSIGNED } from "@/utils/constants/messages";
import { TabListSkeleton } from "@/components/skeletons";
import { isFeaturePermitted } from "@/utils/functions/rbac";
import { getUserId } from '@/utils/functions/TokenFunction';
import { concatenateName } from "@/utils/functions/helperFunctions";

interface GroupUserProps {
    groupUsers: any;
    getUserDetails: (id: string) => void;
    isLoading: boolean;
}

const GroupUsersTab: React.FC<GroupUserProps> = (props) => {
    const currentUserId = getUserId();
    const [isViewUserPermitted, setIsViewUserPermitted] = useState(false);
    const [isUpdateUserPermitted, setIsUpdateUserPermitted] = useState(false);

    useEffect(() => {
        setIsViewUserPermitted(isFeaturePermitted("AdminPortalViewUser"));
        setIsUpdateUserPermitted(isFeaturePermitted("AdminPortalUpdateUser"));
    }, []);

    const onDeleteClicked = (e: React.MouseEvent<HTMLAnchorElement>) => {
        props.getUserDetails(e.currentTarget.id);
    };

    return (
        <div>
            {props.groupUsers && !props.isLoading ? (
                props.groupUsers.length > 0 ? (
                    <div className="gs-list-page-card">
                        <ul className="gs-detail-list">
                            {props.groupUsers.map((user: any, key: number) => (
                                <li className="gs-detail-list-item" key={user.id ?? key}>
                                    <div className="gs-detail-list-name">
                                        <Link className="text-primary hover:underline" to={`/user/${user?.id}`} id={`group-detail-user-tab-name-${key}`}>
                                            {user.email_address} ({concatenateName(user.first_name, user.last_name)})
                                        </Link>
                                    </div>
                                    <div className="gs-detail-list-action">
                                        {isViewUserPermitted &&
                                            isUpdateUserPermitted &&
                                            user?.id !== currentUserId && (
                                                <a href="#" onClick={onDeleteClicked} className="link-primary p-0" id={`group-detail-user-tab-delete-icon-${key}`}>
                                                    <em id={user?.id} className="icon ni ni-trash" />
                                                </a>
                                            )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <div className="gs-list-page-card">
                        <ul className="gs-detail-list">
                            <li className="gs-detail-list-item text-sm text-card-foreground" id="group-detail-user-tab-no-data-message">
                                {NO_USER_ASSIGNED}
                            </li>
                        </ul>
                    </div>
                )
            ) : (
                <TabListSkeleton id="group-user-tab" />
            )}
        </div>
    );
};

export default GroupUsersTab;
